export default {
	tabs: ["Dépôt", "Histoire"],
	History: {
		tabs: ["Révision", "Succès", "Rejet"]
	},
	AccountAmount: "Montant du compte",
	ContactCustomerService: "Contacter le service clientèle",
	NoCustomerService: "Service clientèle occupé",
	tips: "Veuillez soumettre l'évaluation précédente avant de procéder à l'évaluation suivante.!"
};
